import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { MapPinOff, ArrowLeft, Home, LogIn } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("driverToken");

  return (
    <div style={styles.wrapper}>
      <div style={styles.content}>
        
        {/* Animated Illustration */}
        <div style={styles.illustration}>
          <div style={styles.circle}>
            <MapPinOff size={64} color="#EF4444" strokeWidth={1.5} />
          </div>
          <div style={styles.shadow}></div>
        </div>

        {/* Text Content */}
        <h1 style={styles.title}>Lost your way?</h1>
        <p style={styles.text}>
        couldn't find the page you were looking for. It might have been removed or the link is incorrect.
        </p>
        <span style={styles.errorCode}>Error 404</span>

        {/* Action Buttons */}
        <div style={styles.actions}>
          {/* Go Back Button (Native Secondary Style) */}
          <button 
            style={styles.secondaryBtn} 
            onClick={() => navigate(-1)}
            className="native-btn"
          >
            <ArrowLeft size={18} />
            <span>Go Back</span>
          </button>

          {/* Primary Action Button (Native Primary Style) */}
          {isLoggedIn ? (
            <Link to="/dashboard" style={styles.primaryBtn} className="native-btn">
              <Home size={18} />
              <span>Dashboard</span>
            </Link>
          ) : (
            <Link to="/login" style={styles.primaryBtn} className="native-btn">
              <LogIn size={18} />
              <span>Login</span>
            </Link>
          )}
        </div>
      </div>

      {/* Footer Support Link */}
      <div style={styles.footer}>
        <span style={{opacity: 0.6}}>Need help? </span>
        <Link to="/contact" style={styles.link}>Contact Support</Link>
      </div>

      {/* Internal CSS for interactions */}
      <style>{`
        .native-btn { transition: all 0.2s ease; }
        .native-btn:active { transform: scale(0.96); opacity: 0.9; }
        @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#F8FAFC", // Soft native background
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    padding: "20px",
    textAlign: "center",
  },
  content: {
    maxWidth: "400px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  illustration: {
    position: "relative",
    marginBottom: "30px",
    animation: "float 3s ease-in-out infinite",
  },
  circle: {
    width: "120px",
    height: "120px",
    background: "#FEE2E2", // Soft Red bg
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 25px rgba(239, 68, 68, 0.15)",
  },
  shadow: {
    width: "80px",
    height: "10px",
    background: "rgba(0,0,0,0.05)",
    borderRadius: "50%",
    margin: "15px auto 0",
    filter: "blur(4px)",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1E293B",
    marginBottom: "12px",
    letterSpacing: "-0.5px",
  },
  text: {
    fontSize: "15px",
    color: "#64748B",
    lineHeight: "1.5",
    marginBottom: "8px",
  },
  errorCode: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#ff0000",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginBottom: "32px",
  },
  actions: {
    display: "flex",
    gap: "12px",
    width: "100%",
  },
  primaryBtn: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "14px 20px",
    background: "#4F46E5", // Native Primary Brand Color
    color: "#ffffff",
    borderRadius: "14px",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "15px",
    border: "none",
    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
    cursor: "pointer",
  },
  secondaryBtn: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "14px 20px",
    background: "#ffffff",
    color: "#475569",
    borderRadius: "14px",
    border: "1px solid #E2E8F0",
    fontWeight: "600",
    fontSize: "15px",
    cursor: "pointer",
  },
  footer: {
    marginTop: "60px",
    fontSize: "13px",
    color: "#64748B",
  },
  link: {
    color: "#4F46E5",
    fontWeight: "600",
    textDecoration: "none",
  }
};

export default NotFound;